import { useNavigate,Link } from 'react-router-dom';
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { OutlineButton } from 'shared-components/Buttons/Outline';
import PKDHeader from 'components/Home/Header';
import {
  Grid,
  GridItem,
  Title,
  Subtitle,
  Text,
  ContactInfo,
  ButtonContainer,
  StyledLink,
} from './index.styles';
import ResearchImg from 'images/research.png';
import { ReactComponent as PhoneIcon } from 'images/phone.svg';
import { ReactComponent as MailIcon } from 'images/mail.svg';


const SelectDiagnosis = () => {
  const navigate = useNavigate();
  const theme = useTheme();

  return (
    <Box>
      <PKDHeader />
      <Grid
        margin={'10px 162px'}>
        <GridItem>
          <Title>Thank you for your interest</Title>
          <Text>
            This Registry is intended only for patients with Autosomal Dominant
            (ADPKD). However, our collaborators at the University of Alabama at
            Birmingham and Children’s National Medical Center have created a
            database with specific emphasis on ARPKD. If you have questions or
            would like to enroll yourself or your child (alive or deceased) as a
            part of the ARPKD Database, please contact:
          </Text>
          <Grid
            gap='10px' margin='20px 0'>
            <GridItem
              padding='0' gap='10px'>
              <Subtitle>Principal Investigator</Subtitle>
              <ContactInfo>Lisa Guay-Woodford, MD</ContactInfo>
              <StyledLink
                href='tel:202.476.6439'>
                <PhoneIcon /> 202.476.6439
              </StyledLink>
            </GridItem>
            <GridItem
              padding='0' gap='10px'>
              <Subtitle>Research Investigator</Subtitle>
              <ContactInfo>Jasmine Jaber</ContactInfo>
              <StyledLink
                href='tel:202.476.2838'>
                <PhoneIcon /> 202.476.2838
              </StyledLink>
              <StyledLink
                href='mailto:jjaber@childrensnational.org'>
                <MailIcon /> jjaber@childrensnational.org
              </StyledLink>
            </GridItem>
          </Grid>
        </GridItem>
        <GridItem
          gap='20px'>
          <img
            src={ResearchImg} alt='research'
          />
          <Text>
            At this point of time, you are not eligible to participant in the
            registry. Please access our website, PKD Foundation at{' '}
            <Link
              href='https://pkdcure.org/'>
              https://pkdcure.org/
            </Link>{' '}
            to find other ways you can contribute to PKD research.
          </Text>
          <ButtonContainer>
            <OutlineButton
              width='224px'
              height='40px'
              fontFamily='Montserrat-Bold'
              color={theme.palette.primary.blue1}
              borderColor={theme.palette.primary.blue1}
              text='Exit'
              onClickHandler={() => navigate('/')}
            />
          </ButtonContainer>
        </GridItem>
      </Grid>
    </Box>
  );
};

export default SelectDiagnosis;
